import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    enterDetailsManually: 'Enter your details manually',
    noResultCheckForTyposMarkdown: 'Please **check for typos**',
    noResultCompany: 'We couldn’t find your company',
    noResultEi: 'We couldn’t find your business',
    noResultMicro: 'We couldn’t find your micro-enterprise',
    noResultNotAvailableCompany: 'Your company is not (yet) available',
    noResultNotAvailableEi: 'Your business is not (yet) available',
    noResultNotAvailableMicro: 'Your micro-enterprise is not (yet) available',
    noResultTryCodeMarkdown: 'or try with your **SIREN/SIRET**',
    separatorOr: 'or',
  },
  fr: {
    enterDetailsManually: 'Remplir mes informations manuellement',
    noResultCheckForTyposMarkdown:
      'Vérifiez bien **les coquilles** \n ou essayez avec votre **SIRET/SIREN**',
    noResultCompany: 'Nous n’avons pas trouvé votre entreprise',
    noResultEi: 'Nous n’avons pas trouvé votre entreprise',
    noResultMicro: 'Nous n’avons pas trouvé votre micro-entreprise',
    noResultNotAvailableCompany:
      'Votre entreprise n’est pas (encore) \n disponible depuis le registre public',
    noResultNotAvailableEi: 'Votre entreprise n’est pas (encore)',
    noResultNotAvailableMicro: 'Votre micro-entreprise n’est pas (encore)',
    noResultTryCodeMarkdown: 'ou essayez avec votre **SIRET/SIREN**',
    separatorOr: 'ou',
  },
} as const);
